import { HiChevronLeft } from 'react-icons/hi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { formatDateWithTimezoneOffset } from '../../../../../helpers/utils';
import { SUB_REPORT_QUERY_KEY } from '../../../helpers/querySchema';
import SubRExportReportBtn from '../../ExportReportBtn';
import { formatHeaderTitle } from '../utils';

interface IHeaderSectionProps {
  headerTitle: string;
  exportData: any[];
}

const HeaderSection = ({ headerTitle, exportData }: IHeaderSectionProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dashboard, widget } = useParams();

  const handleBackNavigation = () => {
    if (dashboard && widget) {
      const nextQueryParams = new URLSearchParams(location.search);
      nextQueryParams.delete(SUB_REPORT_QUERY_KEY);
      const nextQueryString = nextQueryParams.toString();
      navigate(`/${dashboard}/${widget}/report${nextQueryString ? `?${nextQueryString}` : ''}`);
      return;
    }
    navigate('/');
  };

  const handleExportClick = () => {
    if (!exportData || exportData.length === 0) return;

    // Fields to exclude from export
    const excludeFields = ['offset', 'rownum', 'total_records', 'date'];

    const transformedExportData = exportData.map((row) => {
      const transformedRow: any = {};
      Object.keys(row).forEach((key) => {
        if (!excludeFields.includes(key)) {
          const dateColumn = ['date', 'received_date'].includes(key) ? key : null;
          if (dateColumn && row[dateColumn]) {
            transformedRow[key] = formatDateWithTimezoneOffset(
              row[dateColumn],
              row.offset,
              'MMM dd, yyyy'
            );
          } else {
            transformedRow[key] = row[key];
          }
        }
      });
      return transformedRow;
    });

    const headers = Object.keys(transformedExportData[0]);
    const formattedHeaders = headers.map((header) => formatHeaderTitle(header));
    const rows = transformedExportData.map((row) =>
      headers.map((field) => JSON.stringify(row[field] ?? '')).join(',')
    );
    const csvContent = [formattedHeaders.join(','), ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `Sapaad ${headerTitle}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Wrapper>
      <div className="back-navigation-container">
        <HiChevronLeft className="back-navigation" onClick={handleBackNavigation} />
        <span className="subr-header-title">{headerTitle}</span>
      </div>
      <div className="export-button-container">
        {exportData && exportData.length > 0 ? (
          <SubRExportReportBtn onClick={handleExportClick} />
        ) : null}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 40px 0 20px -10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .back-navigation-container {
    display: flex;
    align-items: center;
  }

  .back-navigation {
    cursor: pointer;
    position: relative;
    top: -2px;
    font-size: 40px;
  }

  .subr-header-title {
    font-size: 24px;
    font-weight: 600;
  }
`;

export default HeaderSection;
